import { MerchantEmailTrigger } from "@redotech/redo-merchant-email-common/merchant-email-trigger";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const sendTestMerchantEmail = {
  name: "sendTestMerchantEmail" as const,
  input: z.object({
    trigger: createEnum(MerchantEmailTrigger),
    htmlTemplate: z.string(),
    subject: z.string(),
    recipientEmail: z.email(),
    /**
     * Manual variable map. Used when teamId is not provided.
     * When teamId IS provided, the server resolves variables from real team
     * data and this field is ignored.
     */
    variables: z.record(z.string(), z.string()).optional(),
    /**
     * If set, the server fetches the team's real data, builds the trigger's
     * payload (for triggers that support it — e.g. RECOVER_WEEKLY_DIGEST),
     * and resolves all template variables automatically. The merchant sees
     * the same numbers the production email would show for this team.
     */
    teamId: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
